import React from "react";
import { makeStyles } from "@material-ui/core/styles";
const widgetHeight = 100;

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(1)
  },
  title: {
    marginBottom: theme.spacing(1)
  },
  uploadInput: {
    display: "none"
  },
  formContainer: {
    height: widgetHeight,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  imagePreviewContainer: {
    marginRight: theme.spacing(2),
    width: widgetHeight,
    height: widgetHeight,
    flexGrow: 0,
    flexShrink: 0,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #999",
    borderRadius: theme.shape.borderRadius,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  imagePreviewContainerNoImage: {
    backgroundColor: theme.palette.grey[200]
  },
  imagePreview: {
    objectFit: "contain",
    width: "100%",
    height: "100%"
  },
  contentContainer: {
    flexGrow: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around"
  },
  progressButtonWrapper: {
    position: "relative",
    marginTop: theme.spacing(1)
  },
  saveButton: {
    ...theme.typography.mcButton
  },
  saveProgressIndicator: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  deleteProgressIndicator: {
    marginRight: theme.spacing(1)
  }
}));
//Avatar Image display - order of precedence
//First, check EWP for that email if avatar available for that profile display image
//Second, check if it is social login and user has a social image display that iamge(diplays only if EWP does
//not have a image)
//Third, display gravatar if no EWP or Social image
//if any of the above image does not exist, atlast resolve to favatar
const AvatarSection = ({ url, processing }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.formContainer}>
        <div className={classes.imagePreviewContainer}>
          {!processing && url && (
            <img
              className={classes.imagePreview}
              src={url}
              alt="ProfileImage"
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default AvatarSection;
